module.exports = __webpack_public_path__ + "static/glyph-115d34102b8531f12cb908aa7b6559f4.png";